export default `
  mutation removeEnterpriseMember($email: String!) {
    removeEnterpriseMember(email: $email) {
      email
      payerUser {
        id
        email
        firstname
        lastname
        stripeCustomerId
      }
    }
  }
`
